import React, { useState, useEffect } from 'react';

import GroupsForm from './GroupsForm';
import { createGroup, loadCompanies, loadCompany } from './services';

export default function GroupCreate({ match, history, updateBreadcrumbs }) {
    const { company_id: companyId } = match.params;
    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        loadCompany(companyId).then(company =>
            updateBreadcrumbs([
                { name: 'Companies', path: '/companies' },
                {
                    name: company.business_name,
                    path: `/companies/${companyId}`,
                },
                'New Company Group',
            ])
        );
        loadCompanies(companyId).then(setCompanies);
    }, []);

    const handleSave = async data => {
        setLoading(true);
        try {
            await createGroup(data, companyId);
            handleCancel();
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = () =>
        history.push(`/companies/${companyId}/partner/company_groups`);

    return (
        <GroupsForm
            mode="edit"
            loading={loading}
            companies={companies}
            onSave={handleSave}
            onCancel={handleCancel}
        />
    );
}
